module.exports = __webpack_public_path__ + "static/media/estrellaDammGlass.f9800b47.jpg";